import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-content-center col-6 col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-3 animate__animated animate__fadeIn animate__faster",
  style: {"cursor":"pointer"}
}
const _hoisted_2 = {
  class: "card",
  style: {"width":"8rem"}
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.img,
        class: "card-img-top",
        alt: _ctx.name
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.name), 1)
      ])
    ])
  ]))
}